export const POST_PUBLISH_OPTIONS = [
  { value: 'published', label: 'Published' },
  { value: 'draft', label: 'Draft' },
  { value: 'archives', label: 'Archives' },
];

export const POST_SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' ,  labelKey: 'sortOptions.latest' },
  { value: 'popular', label: 'Popular' , labelKey: 'sortOptions.popular' },
  { value: 'oldest', label: 'Oldest' , labelKey: 'sortOptions.oldest' },
];
